import { Dimensions } from 'react-native'

const defaultFontSize = Dimensions.get('window').fontScale * 13

export default {
  starFontSize: defaultFontSize,
  minorStarFontSize: defaultFontSize - 2,
  actionFontSize: 18,
}
